var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "project-card" }, [
    _c("div", { staticClass: "project-card-content" }, [
      _c("div", { staticClass: "logo-and-address" }, [
        _c(
          "div",
          { staticClass: "logo-img" },
          [
            _c("fa", {
              staticStyle: { color: "#5AA0FF" },
              attrs: { icon: ["fadr", "house-building"], size: "3x" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "project-address" },
          [
            _vm.projectAddress.line1 ||
            _vm.projectAddress.line2 ||
            _vm.projectAddress.town ||
            _vm.projectAddress.postcode
              ? [
                  _vm._v("\n            " + _vm._s(_vm.projectAddress.line1)),
                  _vm.projectAddress.line1 && _vm.projectAddress.line2
                    ? _c("span", [_vm._v(",")])
                    : _vm._e(),
                  _vm._v("\n            " + _vm._s(_vm.projectAddress.line2)),
                  _vm.projectAddress.line2 && _vm.projectAddress.town
                    ? _c("span", [_vm._v(",")])
                    : _vm._e(),
                  _vm._v("\n            " + _vm._s(_vm.projectAddress.town)),
                  _vm.projectAddress.town && _vm.projectAddress.postcode
                    ? _c("span", [_vm._v(",")])
                    : _vm._e(),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.projectAddress.postcode) +
                      "\n          "
                  ),
                ]
              : [_vm._v("\n            No address provided\n          ")],
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "project-state" }, [
          _vm._v("Current State: " + _vm._s(_vm._f("title")(_vm.serviceState))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "project-total" }, [
          _vm._v(
            "Client Total (Ex Vat):\n          " +
              _vm._s(_vm._f("currencyNotReduced")(_vm.projectTotal)) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "project-card-identifier" }, [
        _vm._v(_vm._s(_vm.projectDetails.ref)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }